import * as React from 'react'

import cn from 'classnames'

import * as styles from './index.vanilla.css'

export type Types = 'brand' | 'primary' | 'radical' | 'negative' | 'wrong' | 'darker' | 'accent'
type Sizes = 'small' | 'medium'
interface Props {
  compact?: boolean
  color?: string
  size?: Sizes
  type?: Types
}

const Separator = ({ color, size = 'medium', type = 'radical', compact }: Props) => {
  return (
    <div
      style={
        color
          ? {
              borderColor: color,
            }
          : {}
      }
      className={cn(styles.separator[size], styles.colorVariants[type], compact && styles.compact)}
    />
  )
}

export default Separator
